import React from 'react';
import Icon from 'utils/components/icon';
import { Timeline, UserInfo } from '../../../../dashboard/components';
import { getActionColor } from '../index';
import MessageLogInfo from '../message-log-info';
import { automationUserMapper, MESSAGE_ACTION_ICONS_MAPPER } from '../audit-log-modal-constants';

interface Props {
  messageEvent: any;
  isSpecialAction: boolean;
  user: string;
}

const AutomationMessageEvent: React.FC<Props> = ({ messageEvent, isSpecialAction, user }) => {
  const { published, currentState, timestamp, action } = messageEvent;
  const iconName = MESSAGE_ACTION_ICONS_MAPPER[currentState];
  const { user: userDisplayName, svgName, description } = automationUserMapper[user] || {};

  return (
    <Timeline.Item>
      <MessageLogInfo
        icon={<Icon className={`${iconName}-icon`} name={iconName} />}
        title={currentState}
        timestamp={timestamp}
        reason={isSpecialAction && action}
        published={published}
        color={getActionColor(currentState)}
      />
      <UserInfo
        icon={<Icon className={'automation-icon'} name={svgName} />}
        userDisplayName={userDisplayName}
        description={description}
      />
    </Timeline.Item>
  );
};

export default AutomationMessageEvent;
